<div class="offering-communities">
  <h1 class="ui-heading-1-bold offering-communities-title">
    {{ section() }}
  </h1>

  @for (community of communities(); track $index) {
    <rds-basic-card layout="horizontal">
      <rds-card-header>
        <rds-card-title
          ><span class="ui-heading-4">
            {{ community.title }}
          </span></rds-card-title
        >
      </rds-card-header>
      <rds-card-content>
        <div class="offering-communities-content">
          <p class="article-body-m">
            {{ community.description }}
          </p>
          <a
            class="link"
            rds-link
            standalone
            [href]="community.url"
            target="_blank"
          >
            {{ BUTTONS.JOIN_NOW }}
            <rds-icon namespace="filled" icon="arrow_right" />
          </a>
        </div>
      </rds-card-content>
    </rds-basic-card>
  }
</div>
